import { useMemo, useState, useEffect } from 'react'
import * as actions from '@actions'
import { useQuery } from '@tanstack/react-query'
import { loadImageWithAuthorization } from '@utils'
import { GCS_BUCKET_DOCUMENTS, GCS_BUCKET_INDEX_DOCUMENTS } from '@constants'

// Borrowed from src/utils/label-studio/label-studio-data.js
const createOcrUrl = (gcsBucket, fileName) => {
    
    const baseUrl = process.env.PARSE_API_BASE_URL
    const imageFileUrl = fileName.replace('.json', '.png')
    
    const url = `${baseUrl}/api/v1/${gcsBucket}/${imageFileUrl}`
    
    console.log('createOcrUrl', url)
    
    return url
    
}

const useKSDocumentExplorerViewModel = () => {
    
    const [documentId, setDocumentId] = useState('')
    const [pageUrls, setPageUrls] = useState({})
    
    const {
        data: document,
        error: documentError,
        isLoading: documentIsLoading,
        refetch: loadDocument,
    } = useQuery({
        queryKey: ['document'],
        queryFn: () => actions.fetchDocumentById(documentId),
        enabled: false,
        retry: 0,
    })
    
    const error = useMemo(() => (
        documentError?.message || documentError?.response?.data?.error
    ), [documentError])
    
    const loading = useMemo(() => (
        documentIsLoading
    ), [documentIsLoading])
    
    useEffect(() => {
        
        if (!document) return
        
        console.log('Document', document)
        
        if (!document.pages?.length) return
        
        setPageUrls([])
        
        document.pages.forEach(page => {
            
            // const img = new Image()
            const gcsBucket = document?.collection?.isParse ? GCS_BUCKET_INDEX_DOCUMENTS : GCS_BUCKET_DOCUMENTS
            const url = createOcrUrl(gcsBucket, page.fileName)
            
            loadImageWithAuthorization(url)
                .then(({ dataUrl }) => {
                    console.log('Loaded async image for LS', dataUrl)
                    // img.src = dataUrl
                    setPageUrls(prev => ({ ...prev, [page.id]: dataUrl }))
                })
                .catch(e => console.error('Failed to load async image for LS', e))
            
        })
        
    }, [document])
    
    return {
        
        // State
        documentId,
        setDocumentId,
        pageUrls,
        setPageUrls,
        
        // Memos
        error,
        loading,
        
        // React Query
        document,
        documentError,
        documentIsLoading,
        loadDocument,
        
        // Methods
        
    }
    
}

export default useKSDocumentExplorerViewModel
